module.exports = __webpack_public_path__ + "img/33153-185.6a5805e3.jpg";